<!-- @format -->

<register-individual-tag>
  <div class="contents">
    <section class="contents_area">
      <individual-form
        if="{ state.phase=='form' }"
        params="{ state.params }"
        prefs="{ state.prefs }"
        errors="{ state.errors }"
        on-confirm="{ onConfirm }"
      ></individual-form>

      <individual-confirm
        if="{ state.phase=='confirm' }"
        params="{ state.params }"
        prefs="{ state.prefs }"
        on-back="{ e => update({ phase: 'form' }) }"
        on-submit="{ onSubmit }"
      ></individual-confirm>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <script>
    import di from "dependeny-injection";
    import routes from "@model/menu-routes.js";
    import form from "./register-individual-form.riot";
    import confirm from "./register-individual-confirm.riot";

    export default {
      components: {
        "individual-form": form,
        "individual-confirm": confirm,
      },
      state: {
        phase: "form",
        params: {},
        prefs: [],
        errors: {},
        registered: false,
      },
      onBeforeMount(props, state) {
        this.MenuApi = di.createApi();
      },
      onMounted() {
        this.MenuApi.request("registerIndividual", "fetch")
          .then((params) => {
            const prefs = params.prefectureMaster;
            delete params.prefectureMaster;
            this.update({ params, prefs, registered: !!params.zip });
          })
          .catch((err) => this.update({ errorMessage: err.message }));
      },
      async onConfirm(params) {
        this.update({ errors: {} });
        try {
          const res = await this.MenuApi.request(
            "registerIndividual",
            "register",
            { phase: "confirm", ...params }
          );
          this.update({ phase: "confirm", params });
        } catch (e) {
          if (e.message == "invalid") {
            this.update({ errors: e.data });
            const container = window.document.querySelector(
              ".container_contents"
            );
            const top =
              this.$("p.error").previousElementSibling.getBoundingClientRect()
                .y + container.scrollTop;
            container.scrollTo({ top: top - 8, behavior: "smooth" });
            di.toast.push("入力に問題があります", "negative");
          } else {
            di.toast.push(e.message, "negative");
          }
        }
      },
      async onSubmit(params) {
        try {
          const res = await this.MenuApi.request(
            "registerIndividual",
            "register",
            { phase: "submit", ...params }
          );
          di.toast.push("登録しました", "success");
          di.router.push(
            routes.makePath("top-tag") + "?modal=register-complete"
          );
          if (!this.state.registered) {
            window.analytics.event("unlock_achievement", {
              achievement_id: "individual_first_registration",
            });
          }
        } catch (e) {
          di.toast.push(e.message, "negative");
        }
      },
    };
  </script>
</register-individual-tag>
